export default "__VITE_ASSET__Colzh8rq__"